import { Flex } from '@backend/lib-design-system';
import type { Property } from 'csstype';
import Image from 'next/image';

import { Link } from '~/components/Link';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';

type Props = {
  justifyContent?: Property.JustifyContent;
};

export const DownloadApp = ({ justifyContent }: Props) => {
  const { language, links } = useBusinessUnitContext();

  return (
    <Flex.Row space="m" justifyContent={justifyContent}>
      <Link href={links.apple_store}>
        <Image src={`/images/brand-badge-app-store-${language}.svg`} alt="App Store" width={127} height={40} />
      </Link>
      <Link href={links.google_store}>
        <Image src={`/images/brand-badge-google-play-${language}.svg`} alt="Google Play" width={136} height={40} />
      </Link>
    </Flex.Row>
  );
};
